import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginatedPlantLineResponse } from '../../plant-setup/model/plantpagination.model';
import { CustomerFilters } from '../models/customer-filters.model';
import { CustomerDetailsRequest } from '../models/request.model';
import {
  CamSpecNameResponse,
  CustomerDetailsResponse,
  PaginatedCustomerInfoResponse,
  PaginatedCustomerLineResponse
} from '../models/response.model';
import { Store } from '@ngxs/store';
import { UserState } from '../../../shared/state/UserState';

export interface AssignPlantsRequest {
  customers: string[];
  plants: string[];
}
@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  public http = inject(HttpClient);
  public store = inject(Store);

  constructor() {}

  getCustomerLines(filters: CustomerFilters, pageNumber: number, pageSize: number): Observable<PaginatedCustomerLineResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getCustomers}`;

    // Remove null or undefined values from filters
    const filteredParams = Object.entries(filters).reduce((acc, [key, value]) => {
      if (value != null) {
        acc[key] = value;
      }
      return acc;
    }, {} as CustomerFilters);

    const params: any = {
      ...filteredParams,
      page: pageNumber,
      userId: this.store.selectSnapshot(UserState.getUserName),
      pageSize
    };

    return this.http.get<PaginatedCustomerLineResponse>(url, { params });
  }

  getAllCamSpecNames(): Observable<CamSpecNameResponse> {
    const url = `${environment.camServiceUrl}${environment.serviceUris.getAllCamSpecNames}`;
    return this.http.get<CamSpecNameResponse>(url);
  }

  getCustomerSettings(customerFk: string): Observable<CustomerDetailsResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getCustomerSettings}`;

    return this.http.get<CustomerDetailsResponse>(url, {
      params: { customerFk }
    });
  }

  getAssociateCustomers(customerId: string, page: number, limit: number): Observable<PaginatedCustomerInfoResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getAssociateCustomer}`;
    return this.http.get<PaginatedCustomerInfoResponse>(url, {
      params: { customerId, page, pageSize: limit }
    });
  }
  getPlantList(pageNumber: number, pageSize: number): Observable<PaginatedPlantLineResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getAllPlants}`;
    return this.http.get<PaginatedPlantLineResponse>(url, {
      params: { page: pageNumber, pageSize: pageSize }
    });
  }

  assignPlantToCustomer(payload: AssignPlantsRequest): Observable<string> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.updatePlantAssociation}`;
    return this.http.post<string>(url, payload);
  }

  updateCustomerSettings(
    customerDetailsRequest: CustomerDetailsRequest,
    customerId: string,
    user: string
  ): Observable<CustomerDetailsResponse> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.updateCustomerDetails}?customerFk=${customerId}`;
    return this.http.put<CustomerDetailsResponse>(url, customerDetailsRequest, { headers: { user } });
  }

  customerCodeExists(code: string): Observable<boolean> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.customerCodeExists}`;
    return this.http.get<boolean>(url, { params: { code } });
  }

  syncLabels(): Observable<string> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.syncLabels}`;
    return this.http.get<string>(url);
  }
}
